/** Turn API stock errors into plain language for shoppers. */
export const parseStockErrorMessage = (message) => {
  if (!message || typeof message !== "string") {
    return null;
  }

  const insufficient = message.match(
    /Insufficient stock for (.+?)\.\s*Only (\d+) available\.?/i
  );
  if (insufficient) {
    const name = insufficient[1].trim();
    const available = parseInt(insufficient[2], 10);
    if (available <= 0) {
      return `${name} is sold out (0 left in store). It was removed from your cart. You can continue with your other items or shop for something else.`;
    }
    return `${name} only has ${available} left in stock. Your cart was adjusted — please check quantities and try again.`;
  }

  if (/out of stock/i.test(message)) {
    return message;
  }

  return null;
};

export const getCartStockBannerText = (result) => {
  if (!result?.hadChanges && !result?.issues?.length) return null;

  const outOfStock = (result.issues || []).filter(
    (i) => i.status === "out_of_stock" || i.available === 0
  );
  if (outOfStock.length) {
    const names = outOfStock.map((i) => i.name).join(", ");
    return `${names} ${outOfStock.length === 1 ? "is" : "are"} sold out and ${outOfStock.length === 1 ? "was" : "were"} removed from your cart.`;
  }

  if (result.hadChanges) {
    return "Some cart quantities were updated to match what is actually in stock. Please review your cart before checkout.";
  }

  return null;
};
